import { motion } from "framer-motion";
import { ServiceIllustration } from "./ServiceIllustration";

const capabilities = [
  {
    n: "01",
    accent: "#1B36F9",
    title: "Find the buyers",
    outcome: "Target accounts, buying signals and decision-maker research.",
  },
  {
    n: "02",
    accent: "#FF4400",
    title: "Win attention",
    outcome: "Personalised email, calls, LinkedIn and content that give buyers a reason to reply.",
  },
  {
    n: "03",
    accent: "#1B36F9",
    title: "Close the deals",
    outcome:
      "Follow-up, proposals and negotiation through to payment.",
  },
  {
    n: "04",
    accent: "#FF4400",
    title: "Protect selling time",
    outcome:
      "AI research, CRM updates and follow-up admin, so reps spend more time selling.",
  },
];

export const Services = () => {
  return (
    <section id="services" className="bg-paper border-t border-ink" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-10 md:py-14">
        <h2 className="font-display font-semibold tracking-[-0.02em] text-4xl md:text-5xl lg:text-7xl leading-[0.92] text-ink max-w-5xl text-balance">
          <span className="block">We find the buyers.</span>
          <span className="block">
            We close the <span className="font-editorial italic font-medium text-cobalt">deals.</span>
          </span>
        </h2>
        <p className="mt-5 text-xl md:text-2xl font-light text-ink leading-relaxed max-w-3xl text-pretty">
          We build and manage your sales team, or unify your existing team to get sales 2x faster.
        </p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {capabilities.map((s, i) => {
            return (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: (i % 2) * 0.08, ease: [0.22, 1, 0.36, 1] }}
                style={{ "--accent": s.accent }}
                className="group relative bg-surface-light border border-ink p-6 md:p-8 flex flex-col transition-[transform,box-shadow] duration-300 hover:-translate-y-1.5 hover:shadow-hard"
                data-testid={`service-card-${i}`}
              >
                <div className="absolute left-0 top-0 h-full w-1.5 [background-color:var(--accent)]" />
                <ServiceIllustration index={i} />
                <h3 className="font-display text-2xl md:text-3xl font-semibold tracking-tight text-ink text-balance"><span className="mr-3 text-cobalt">{s.n}</span>{s.title}</h3>
                <p className="mt-3 text-xl md:text-2xl font-light leading-relaxed text-ink text-pretty">{s.outcome}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
